// Pricing Plans Data Configuration
// This file contains all pricing plan configurations used across different components

export const pricingPlans = {
  basic: {
    label: "Basic",
    price: "9.99",
    duration: 1,
    planId: "basic",
    description: "For qualified tradespeople who want a verified profile, showcase their work, and connect with local customers.",
    buttonText: "Get 28 days free trial",
    listItems: [
      "No credit card required for trial",
      "1 keyword",
      "2 posts",
      "1 image per post",
      "Portfolio gallery with 8 images",
      // "Licences and badges",
      "Core metrics and insights",
    ],
    pricingColor: "text-offblack",
    tagging: true,
  },
  pro: {
    label: "Pro",
    price: "19.99",
    duration: 1,
    planId: "premium",
    description: "For growing businesses that want stronger reach, more posts, and full access to customer insights and contact options.",
    buttonText: "Sign Up Pro",
    listItems: [
      "Priority search placement",
      "10× profile reach",
      "5 keywords",
      "10 posts",
      "10 featured posts",
      "5 images per post",
      "Portfolio gallery with 20 images",
      "Licences and badges",
      "Core metrics and insights",
      "Advanced metrics and analytics",
      "Business contact details",
    ],
    pricingColor: "text-offblack",
    tagging: false,
  }
};

// Helper function to get pricing plan data
export const getPricingPlan = (planType) => {
  return pricingPlans[planType];
};

// Helper function to get all pricing plans
export const getPricingPlans = () => {
  return Object.values(pricingPlans);
};

export default pricingPlans;
